import { IHttpService, IPromise } from 'angular';
import { GmcApi } from '../../constants/gmc-api';
import { IServerRes } from '../../interfaces';

export class PasswordService {
  static $inject = [
    '$http',
    'GmcApi'
  ];

  constructor( private $http: IHttpService,
               private gmcApi: GmcApi ) {
  }

  changePassword( current_password: string, new_password: string ): IPromise<any> {
    return this.$http.post(this.gmcApi.user.changePassword, { current_password, new_password })
      .then(( res ) => res.data);
  }

  resetPassword( email: string ): IPromise<any> {
    return this.$http.post<IServerRes>(this.gmcApi.auth.restorePassword, { username: email })
      .then(( res ) => res.data);
  }
}



// WEBPACK FOOTER //
// ./app/core/services/password/password.service.ts